import { Link } from "react-router-dom";
import { Phone, ArrowUpRight, Check } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { BUSINESS, SERVICES } from "../lib/content";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow="Our Services"
        title="Pave."
        accent="Seal. Repair."
        subtitle="Complete asphalt services for residential, commercial, industrial and municipal clients across the prairies."
        testId="services-hero"
      />

      {/* Services List */}
      <section className="py-20 md:py-28" data-testid="services-list">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 space-y-24 md:space-y-32">
          {SERVICES.map((s, i) => {
            const flip = i % 2 === 1;
            return (
              <div
                key={s.slug}
                className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
                  flip ? "lg:[&>div:first-child]:order-2" : ""
                }`}
                data-testid={`service-${s.slug}`}
              >
                <div className="lg:col-span-6">
                  <div className="aspect-[4/3] relative overflow-hidden border border-[#27272a] group">
                    <img
                      src={s.image}
                      alt={s.title}
                      className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
                    />
                    <div className="absolute top-5 left-5 w-12 h-12 bg-[#f59e0b] text-[#09090b] flex items-center justify-center font-display font-black text-base">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                  </div>
                </div>

                <div className="lg:col-span-6">
                  <div className="label-sm text-[#f59e0b] mb-5">
                    Service · {String(i + 1).padStart(2, "0")}
                  </div>
                  <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl uppercase leading-[0.9] mb-6">
                    {s.title}
                  </h2>
                  <p className="text-[#d4d4d8] text-lg leading-relaxed mb-6">
                    {s.long}
                  </p>

                  <ul className="space-y-3 mb-10">
                    {s.points.map((pt, j) => (
                      <li
                        key={j}
                        className="flex items-start gap-3 text-[#fafaf9]"
                      >
                        <Check
                          className="w-5 h-5 text-[#f59e0b] mt-0.5 shrink-0"
                          strokeWidth={3}
                        />
                        <span>{pt}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      href={`tel:${BUSINESS.phoneRaw}`}
                      className="inline-flex items-center gap-3 bg-[#f59e0b] hover:bg-[#d97706] text-[#09090b] font-bold px-8 py-5 text-sm uppercase tracking-[0.25em] transition-colors"
                      data-testid={`service-${s.slug}-call`}
                    >
                      <Phone className="w-4 h-4" strokeWidth={3} />
                      Request quote
                    </a>
                    <Link
                      to="/contact"
                      className="inline-flex items-center gap-3 border border-[#3f3f46] hover:border-[#f59e0b] text-[#fafaf9] font-bold px-8 py-5 text-sm uppercase tracking-[0.25em] transition-colors"
                      data-testid={`service-${s.slug}-contact`}
                    >
                      Contact us
                      <ArrowUpRight className="w-4 h-4" strokeWidth={3} />
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Bottom CTA */}
      <section
        className="py-24 md:py-32 bg-[#050505] border-t border-[#27272a]"
        data-testid="services-cta"
      >
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 text-center">
          <div className="label-sm text-[#f59e0b] mb-5">Don't see your project?</div>
          <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl uppercase leading-[0.9] mb-8 max-w-3xl mx-auto">
            Residential. Commercial.
            <br />
            <span className="text-[#f59e0b]">Industrial. Municipal.</span>
          </h2>
          <p className="text-[#a1a1aa] max-w-2xl mx-auto mb-10 text-lg">
            If it needs paving, sealing, repairing or maintaining — we handle
            it. Call for a no-obligation site visit and written quote.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              className="inline-flex items-center gap-3 bg-[#f59e0b] hover:bg-[#d97706] text-[#09090b] font-bold px-8 py-5 text-sm uppercase tracking-[0.25em] transition-colors"
              data-testid="services-bottom-call"
            >
              <Phone className="w-4 h-4" strokeWidth={3} />
              {BUSINESS.phone}
            </a>
            <a
              href={`tel:${BUSINESS.phone2Raw}`}
              className="inline-flex items-center gap-3 border border-[#3f3f46] hover:border-[#f59e0b] text-[#fafaf9] font-bold px-8 py-5 text-sm uppercase tracking-[0.25em] transition-colors"
              data-testid="services-bottom-call-2"
            >
              <Phone className="w-4 h-4 text-[#f59e0b]" strokeWidth={3} />
              {BUSINESS.phone2}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
